import React from "react";
import NotFound from "theme/pages/NotFound";
import { Category, Product, CmsPage } from "web/LoadableRoutes";
import RedirectEntity from "web/RedirectEntity";
import customDispatchRoutes from "web/core/router/customDispatchRoutes";
import makeQueryFromLocation from "web/theme/modules/Layer/makeQueryFromLocation";
import { Route } from "react-router";

export const onInit = ({ actions }) => {
  actions.registerDispatchRoute("NotFoundEntity", {
    render: () => <NotFound />,
  });

  actions.registerDispatchRoute("RedirectEntity", {
    render: (props) => {
      return (
        <Route
          render={({ staticContext }) => {
            if (staticContext && props.matched.redirectType) {
              staticContext.status = props.matched.redirectType;
            }
            return <RedirectEntity entity={props.matched} />;
          }}
        />
      );
    },
  });

  actions.registerDispatchRoute("Category", {
    render: (props) => (
      <Category
        id={props.matched.id}
        category={props.matched}
        loading={props.loading}
        location={props.location}
      />
    ),
    variables: (params) => {
      const query = makeQueryFromLocation(params.location);
      return query.getFacetsParams();
    },
  });

  actions.registerDispatchRoute("Product", {
    render: (props) => (
      <Product
        sku={String(props.matched.identifier)}
        product={props.matched}
        loading={props.loading}
        location={props.location}
      />
    ),
  });

  actions.registerDispatchRoute("CmsPage", {
    render: (props) => (
      <CmsPage
        id={String(props.matched.identifier)}
        cms={props.matched}
        loading={props.loading}
      />
    ),
  });

  Object.keys(customDispatchRoutes).forEach((type) => {
    const routeDefinition =
      typeof customDispatchRoutes[type] === "function"
        ? {
            render: customDispatchRoutes[type],
          }
        : customDispatchRoutes[type];

    actions.registerDispatchRoute(type, routeDefinition);
  });
};
